export type HomeSearchSampleIcon =
  | 'filter'
  | 'evidence'
  | 'gap'
  | 'presentation'
  | 'compare'
  | 'interdisciplinary';

export interface HomeSearchSampleItem {
  query: string;
}

export interface HomeSearchSampleGroup {
  type: string;
  icon: HomeSearchSampleIcon;
  items: HomeSearchSampleItem[];
}

export const homeSearchSampleGroups: HomeSearchSampleGroup[] = [
  {
    type: '限定检索条件',
    icon: 'filter',
    items: [
      {
        query: '固态电池近三年的研究进展',
      },
      {
        query: 'mRNA疫苗，IF大于5的研究',
      },
      {
        query: 'Eric Topol近5年在Nature Medicine发表人工智能在医学领域应用的文献',
      },
    ],
  },
  {
    type: '整理文献证据',
    icon: 'evidence',
    items: [
      {
        query: 'HPV疫苗预防宫颈癌的关键证据、机制和临床应用脉络',
      },
      {
        query:
          '硫化物固态电解质在全固态电池中的界面失效机制与改性策略证据整理',
      },
      {
        query: '妊娠期使用SSRI抗抑郁药的胎儿安全性证据',
      },
    ],
  },
  {
    type: '找研究方向与研究空白',
    icon: 'gap',
    items: [
      {
        query: '固态电池硫化物电解质界面稳定性领域有哪些值得进一步研究的选题',
      },
      {
        query: '生成式AI在教育中的研究热点、应用场景和可选研究方向',
      },
      {
        query: '硫化物固态电解质界面稳定性研究中尚未解决的关键问题',
      },
    ],
  },
  {
    type: '学术汇报与科普材料',
    icon: 'presentation',
    items: [
      {
        query:
          '围绕生成式AI对学生学习效果和认知负荷，整理一份适合组会汇报的文献要点',
      },
      {
        query: 'HPV疫苗为什么可以预防宫颈癌',
      },
      {
        query: '机器学习辅助钙钛矿材料稳定性提升的研究进展',
      },
    ],
  },
  {
    type: '竞品与技术路线对比',
    icon: 'compare',
    items: [
      {
        query: '不同ADC药物相关间质性肺病发生率和管理策略比较',
      },
      {
        query: 'GLP-1受体激动剂与替尔泊肽减重效果、停药反弹和安全性比较',
      },
      {
        query: '钠离子电池与锂离子电池在储能应用中的技术路线和产业化前景比较',
      },
    ],
  },
  {
    type: '跨领域研究',
    icon: 'interdisciplinary',
    items: [
      {
        query: '碳市场、气候金融与企业ESG信息披露的跨学科研究进展',
      },
      {
        query: '极端降雨背景下城市内涝韧性评估研究进展',
      },
      {
        query: '后疫情时代科学传播与公众信任的影响机制研究',
      },
    ],
  },
];
